var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"direction-scrolling-settings"},[_c('div',{staticClass:"direction-scrolling-wrapper"},[_c('div',{staticClass:"title"},[_c('h3',[_vm._v(" "+_vm._s(_vm.titleText)+" ")]),(_vm.isForMobile)?_c('MobileIcon'):_c('DesktopIcon')],1),_c('div',{staticClass:"direction-scrolling-container"},_vm._l((_vm.computedDirections),function(direction){return _c('button',{key:direction.name,staticClass:"direction-icon",class:{
          selected: _vm.isHorizontalSwipe === direction.value,
        },on:{"click":function($event){return _vm.onSwipeDirectionChange({
            inputFor: _vm.isForMobile
              ? 'isHorizontalSwipeOnMobile'
              : 'isHorizontalSwipe',
            value: direction.value,
          })}}},[_c(direction.icon,{tag:"component"})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }